/**
 * URL에서 지정된 쿼리 파라미터들을 제거하는 함수
 * @param paramsToRemove 제거할 쿼리 파라미터 이름 배열
 * @param options 추가 옵션 (replace: URL을 바꿀지 여부)
 * @returns 업데이트된 URL 문자열
 * (완료 후 브라우저 히스토리를 남기지 않습니다.)
 */
export default function removeSearchParams(
  paramsToRemove: string[],
  options: { replace?: boolean } = { replace: true },
): string {
  if (typeof window === 'undefined') {
    return '';
  }

  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);

  paramsToRemove.forEach((param) => {
    searchParams.delete(param);
  });

  const queryString = searchParams.toString() ? `?${searchParams.toString()}` : '';
  const newUrl = `${currentUrl.pathname}${queryString}${currentUrl.hash}`;

  if (options.replace) {
    window.history.replaceState({}, '', newUrl);
  }

  return newUrl;
}
